<template>
  <div
    class="dropdown-navigation"
    @mouseenter="$emit('mouseenter', $event)"
    @mouseleave="$emit('mouseleave', $event)"
  >
    <ul class="parent-categories" v-if="isLoading">
      <li :key="index" v-for="index in 15">
        <blockShimmer
          class="p-3"
          width="100%"
          height="1.2rem"
          style="--shimmer-color: #d7d5d1"
        />
      </li>
    </ul>
    <ul class="parent-categories" v-else>
      <li
        :key="category.uuid"
        v-for="category in categories"
        @mouseover="activeSubCategory = category"
      >
        <router-link
          class="d-flex align-items-center drop"
          :class="{ active: activeSubCategory.uuid === category.uuid }"
          :to="{
            name: 'product-category',
            params: { category: category.uuid },
          }"
        >
          <h6>{{ category.name }}</h6>
          <span class="ml-auto icon" v-show="category.sub_categories.length">
            <i class="fi fi-rr-angle-small-right"></i>
          </span>
        </router-link>
      </li>
    </ul>
    <div
      class="sub-categories"
      v-if="activeSubCategories.length"
      ref="subCategories"
    >
      <ul
        class="sub-category"
        v-for="category in activeSubCategories"
        :key="category.uuid"
      >
        <li class="head">
          <router-link
            class="d-flex align-items-center drop"
            :to="{
              name: 'product-category',
              params: { category: category.uuid },
            }"
          >
            <h6>{{ category.name }}</h6>
          </router-link>
        </li>
        <li
          v-for="productLine in category.product_lines"
          :key="productLine.uuid"
        >
          <router-link
            class="d-flex align-items-center drop"
            :to="{
              name: 'product-category',
              params: { category: productLine.uuid },
            }"
          >
            <span>{{ productLine.name }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, ref, watch } from "vue";
import { blockShimmer } from "vue-shimmer";

defineProps(["categories", "onClose", "isLoading"]);

const activeSubCategory = ref({});
const subCategories = ref(null);

const activeSubCategories = computed(
  () => activeSubCategory.value?.sub_categories || []
);

watch(activeSubCategory, () => {
  if (subCategories.value) {
    subCategories.value.scrollLeft = 0;
  }
});
</script>

<style scoped>
.dropdown-navigation {
  --container-width: calc(
    1240px - 30px
  ); /* .container max-width minus it's padding (left + right) */
  height: max(28.1rem, 40vh);
  background-color: #fff;
  position: absolute;
  top: calc(100% + 1.3rem);
  left: 0%;
  display: flex;
  overflow: hidden;
  z-index: 1;
  border-top: 1px solid var(--gray-200);
  border-bottom: 1px solid var(--gray-200);
  width: auto;
}

.dropdown-navigation .parent-categories {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  width: calc(var(--container-width) / 4);
  border-right: 1px solid var(--gray-25);
}

.dropdown-navigation .parent-categories li a {
  color: #000;
  padding: 0.5rem 1.25rem;
  min-height: 3.44rem;
  white-space: nowrap;
}

.dropdown-navigation .parent-categories li span {
  background-color: #fff;
}

.dropdown-navigation .parent-categories li a:hover,
.dropdown-navigation .parent-categories li a.active {
  text-decoration: none;
  font-weight: 700;
  color: var(--primary-color);
  background-color: var(--gray-50);
}

.dropdown-navigation .parent-categories li a:hover h6 {
  font-weight: 600;
}

.dropdown-navigation .parent-categories li a:hover i {
  color: inherit;
}

.dropdown-navigation .sub-categories {
  width: calc(var(--container-width) * 3 / 4);
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 100%;
  row-gap: 1rem;
  column-gap: 2.5rem;
  overflow-x: scroll;
  overflow-y: hidden;
}

.dropdown-navigation .sub-categories .sub-category {
  min-width: 11.25rem;
}

.dropdown-navigation .sub-categories .sub-category .head {
  border-bottom: 1px solid #646669;
}

.dropdown-navigation .sub-categories .sub-category .head h6 {
  color: #000;
  font-size: 1rem;
  font-weight: 500;
}

.dropdown-navigation .sub-categories .sub-category li a {
  color: #646669;
  padding: 0.625rem;
  font-size: 0.9rem;
}

.dropdown-navigation .sub-categories .sub-category li a:hover {
  text-decoration: none;
  font-weight: 700;
  color: var(--primary-color);
  background-color: var(--gray-50);
}

@media only screen and (max-width: 1240px) {
  .dropdown-navigation {
    --container-width: calc(100vw - 30px);
  }
}

@media only screen and (max-height: 750px) {
  .dropdown-navigation {
    height: 60vh;
  }
}
</style>
